import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, TextField, MenuItem } from "@mui/material";
import { Search } from "@mui/icons-material";

export const ProviderWorkflowMonitoringFilters = ({
  filters,
  setFilters,
  onSearch,
}) => {
  const handleSetFilters = (event) => {
    setFilters((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <Grid container className="provider-filters">
      <Grid
        xs={12}
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={2}
      >
        <Box sx={{ flex: 1 }}>
          <TextField
            label="RowKey"
            size="small"
            name="rowKey"
            value={filters.rowKey || ""}
            onChange={handleSetFilters}
            fullWidth
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <TextField
            label="Creation Date"
            type="date"
            size="small"
            name="creationDate"
            value={filters.creationDate || ""}
            onChange={handleSetFilters}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <TextField
            label="Last Modification Date"
            type="date"
            size="small"
            name="lastModificationDate"
            value={filters.lastModificationDate || ""}
            onChange={handleSetFilters}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <TextField
            label="Source File"
            size="small"
            name="sourceFile"
            value={filters.sourceFile || ""}
            onChange={handleSetFilters}
            fullWidth
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <TextField
            select
            label="Status"
            size="small"
            name="status"
            value={filters.status || ""}
            onChange={handleSetFilters}
            fullWidth
          >
            +{" "}
            <MenuItem value="SourceFileCopyStarted">
              SourceFileCopyStarted
            </MenuItem>
            +{" "}
            <MenuItem value="BronzeLayerJobStarted">
              BronzeLayerJobStarted
            </MenuItem>
            +{" "}
            <MenuItem value="MediaDownloadInProgress">
              MediaDownloadInProgress
            </MenuItem>
            + <MenuItem value="Completed">Completed</MenuItem>+{" "}
            <MenuItem value="Silver2JobStarted">Silver2JobStarted</MenuItem>+{" "}
            <MenuItem value="NotStarted">NotStarted</MenuItem>
          </TextField>
        </Box>

        <Button
          startIcon={<Search />}
          variant="contained"
          color="secondary"
          onClick={onSearch}
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};

ProviderWorkflowMonitoringFilters.propTypes = {
  filters: PropTypes.shape({
    rowKey: PropTypes.string,
    creationDate: PropTypes.string,
    lastModificationDate: PropTypes.string,
    sourceFile: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};
